import React from "react";
import { Routes, Route } from "react-router-dom";
import styled from "styled-components";

import Home from "../Views/Home";
import Help from "../Views/Help";
import Transfers from "../Views/Transfers";
import UserTransfers from "../Views/UserTransfers";

const Body: React.FC = () => (
  <Wrapper>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/transfers" element={<Transfers />} />
      <Route path="/history" element={<UserTransfers />} />
      <Route path="/help" element={<Help />} />
    </Routes>
  </Wrapper>
);

const Wrapper = styled.div`
  padding: 10px;
`;

export default Body;
